export function getAddSessionGuidingText(
  multipleSessions: { value?: number }[],
  minSession: number,
  maxSession: number,
) {
  const isAllSessionsCompleted = multipleSessions.every((field) => field.value !== undefined);

  if (!isAllSessionsCompleted && multipleSessions.length <= minSession) {
    return 'กรุณากรอกระยะเวลาสอบทั้งช่วงที่ 1 และ 2 ให้ครบถ้วนก่อนเพิ่มช่วงสอบใหม่';
  }

  if (multipleSessions.length >= maxSession) {
    return `ไม่สามารถเพิ่มช่วงสอบได้อีก (สูงสุด ${maxSession} ช่วงเท่านั้น)`;
  }

  return '';
}
